exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/rewards-table/rewards-table.component.scss
// module id = ../../../../../../../../src/app/referral-magic/rewards-table/rewards-table.component.scss
// module chunks = 1